module.exports = __webpack_public_path__ + "img/bed.20f81abc.svg";